// src/components/LoadingGate.jsx
import React from "react";

export default function LoadingGate({ progress }) {
  const { done, total, current } = progress;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        minHeight: "100dvh",
        padding: 24,
      }}
    >
      <div style={{ width: 360, maxWidth: "90vw" }}>
        <div style={{ marginBottom: 8, fontWeight: 600 }}>
          Preparing your app {total ? `(${done}/${total})` : null}
        </div>
        <div
          aria-label="progress"
          style={{ height: 8, background: "#eee", borderRadius: 999 }}
        >
          <div
            style={{
              width: `${pct}%`,
              height: "100%",
              borderRadius: 999,
              background: "#0d6efd",
            }}
          />
        </div>
        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
          {current ?? "…"}
        </div>
      </div>
    </div>
  );
}
